// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionRedo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M16.716 7.467H8.84a4.766 4.766 0 00-4.766 4.766A4.764 4.764 0 008.84 17h9.967v-1.733H8.841a3.033 3.033 0 110-6.067h7.875l-1.95 1.95 1.225 1.226 4.043-4.043-4.043-4.042-1.225 1.226 1.95 1.95z" />
  </svg>
);

export default ActionRedo;
